import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

import RpMUIModalBase from "../modals/RpMUIModal";

type PaymentInfoMsgProps = {
  makePayment?: boolean;
};

const RpMUIModal = RpMUIModalBase as unknown as React.ComponentType<{
  children: React.ReactNode;
  closeAfterTransition?: boolean;
  maxWidth?: string;
  onClose: () => void;
  open: boolean;
  persists?: boolean;
  style?: React.CSSProperties;
}>;

function PaymentInfoMsg({ makePayment }: PaymentInfoMsgProps) {
  const [openInfo, setOpenInfo] = useState(true);
  if (!makePayment) return null;
  return (
    <RpMUIModal
      open={openInfo && makePayment ? true : false}
      onClose={() => setOpenInfo(false)}
      maxWidth="sm"
      style={{ zIndex: "9999999" }}
      persists
      closeAfterTransition
    >
      <div>
        <div className="text-center">
          <WarningIcon className="text-warning" fontSize="large" />
        </div>
        <Typography variant="h6" className="text-center" gutterBottom>
          Important Payment Information
        </Typography>
        <Typography variant="body1" className="text-center" gutterBottom>
          Please do not press the back button or refresh this page while your
          payment is being processed. Doing so may interrupt the transaction and
          could lead to delays or errors.
        </Typography>
        <Typography variant="body1" className="text-center">
          Thank you for your understanding!
        </Typography>
        <div className="text-center mt-5 mb-3">
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenInfo(false)}
            className="px-5"
          >
            OK
          </Button>
        </div>
      </div>
    </RpMUIModal>
  );
}

export default PaymentInfoMsg;
